import React from 'react';
import InputText from '../ReusableComponents/InputText';
import { format, isValid } from 'date-fns';
import TextArea from '../ReusableComponents/TextArea';

const HolidayPopup = ({ data }) => {

  return (
    // <div className="mx-auto md:w-2/5 w-full border-black">
    //   <div className="relative w-full h-full max-w-xl md:h-auto">
    //     <div className="relative bg-white rounded-lg shadow">
    //       <div className="px-6 py-6 lg:px-8">
    //         <form className="space-y-6">
    <div class="w-full ">
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 p-4">
      <InputText
        inputType="date"
        title="Date"
        classStar="text-red-500"
        name="date"
        disabled={true}
        content={
          data.Date && isValid(new Date(data.Date))
            ? format(new Date(data.Date), "yyyy-MM-dd")
            : ""
        }
        inputClassName="w-1/4"
      />
      <InputText
        inputType="text"
        title="Day"
        name="day"
        classStar="text-red-500"
        maxLength={100}
        content={data.Day}

        disabled={true}
      />
      <InputText
        inputType="text"
        title="Holiday"
        name="holiday"
        classStar="text-red-500"
        maxLength={100}
        content={data.Holiday}
        disabled={true}
        inputClassName="w-1/4"
      />

    </div>
  <div className="p-4">

        <TextArea
          title="Description"
          rows={7}
          name="description"
          content={data?.Description}
          resize={false}
          placeholder="Enter description"
          disabled={true}
          // tabIndex="0"
        />
      </div>
   </div>
    
  );
};

export default HolidayPopup;

